import { render, staticRenderFns } from "./CompletionCard.vue?vue&type=template&id=1e8e8f2f&scoped=true&"
import script from "./CompletionCard.vue?vue&type=script&lang=ts&"
export * from "./CompletionCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e8e8f2f",
  null
  
)

export default component.exports